import script from "./tpr.vue?vue&type=script&setup=true&lang=js"
export * from "./tpr.vue?vue&type=script&setup=true&lang=js"

import "./tpr.vue?vue&type=style&index=0&id=34097886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34097886"]])

export default __exports__